import { AnalyticsEventPayloads, AnalyticsEvent } from '../../analytics/analyticsEvent';
import { SideBarItemEnum } from '../BaseIndex/helpers/SideBarItems';

type ScreenOpenedScreen = AnalyticsEventPayloads[AnalyticsEvent.screenOpened]['screen'];

// The app.screen.opened screen for a space URL, matched in the order Space has always used.
export const getSpaceScreen = (pathname: string): ScreenOpenedScreen | null => {
  if (pathname.includes(SideBarItemEnum.triage)) return 'triage';
  if (pathname.includes(SideBarItemEnum.archive)) return 'archive';
  if (pathname.includes(SideBarItemEnum.backlog)) return 'backlog';
  if (pathname.includes(SideBarItemEnum.epics)) return 'epics';
  if (pathname.includes(SideBarItemEnum.planning)) return 'planning';
  if (pathname.includes(SideBarItemEnum.sprint)) return 'sprint';
  if (pathname.includes(SideBarItemEnum.kanban)) return 'kanban';
  return null;
};
